import version from '../../../package.json';
import React from 'react';
import { Typography, TypographyVariantsEnum } from '@mindly/ui-components';

type BuildInformationPropsType = {
  className?: string;
};
const BuildInformation: React.FC<BuildInformationPropsType> = ({ className }) => {
  return (
    <Typography variant={TypographyVariantsEnum.Tabbar10Medium} opacity={50} className={className} align={'center'}>
      v{version.version} ({version['code-version']})<br />
      {import.meta.env.VITE_APP_ENV === 'main'
        ? 'Production Build'
        : import.meta.env.VITE_APP_ENV?.includes('release')
          ? 'Pre-production Build'
          : 'Develop Build'}
    </Typography>
  );
};

export default React.memo(BuildInformation);
